import { signOut } from '../store/slices/user';
import { store } from '../store/store';
import { API_URL } from './../functions/environmentVariables';
import axios from 'axios';
import {
  getTokenDetails,
  removeTokenDetails,
  removeSessionDetails,
} from '../functions/userSession';

// Use the existing getTokenDetails function for consistency
const getTokenFromLocalStorage = (): string | null => {
  return getTokenDetails();
};

export const appAxios = axios.create({
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
  baseURL: API_URL,
  validateStatus: (status) => status <= 500,
});

appAxios.interceptors.request.use(
  (config) => {
    // Check localStorage first for immediate availability
    let token = getTokenFromLocalStorage();

    // If not in localStorage, check Redux store
    if (!token) {
      const appState = store.getState();
      token = appState.user.token;
    }

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

appAxios.interceptors.response.use(
  (res) => {
    return res;
  },
  async (err) => {
    const originalConfig = err.config;

    if (err.code === 'ERR_NETWORK' && !originalConfig._retry) {
      originalConfig._retry = true;
      return appAxios(originalConfig);
    }

    if (err.response?.status === 401) {
      // Clear both token and session on 401
      removeTokenDetails();
      removeSessionDetails();
      store.dispatch(signOut());

      // Redirect to login page
      if (typeof window !== 'undefined') {
        window.location.href = '/login';
      }
    }

    return Promise.reject(err);
  }
);
